import React, { useState } from "react";
import { FaFilePdf, FaTimes } from "react-icons/fa";

import "./DocumentosGestion.css";

// PDFs
import pdfPEI from "../assets/transparencia/doc_gestion/PEI_2025.pdf";
import pdfRegistro from "../assets/transparencia/doc_gestion/ManualRegistraGilda.pdf";
import pdfTitula from "../assets/transparencia/doc_gestion/ManualTitulaGilda.pdf";

const documentos = [
  { titulo: "23/10/2025 PROYECTO EDUCATIVO INSTITUCIONAL PEI", pdf: pdfPEI },
  { titulo: "27/10/2025 MANUAL DEL SISTEMA DE REGISTRO ACADÉMICO", pdf: pdfRegistro },
  { titulo: "27/10/2025 MANUAL DEL SISTEMA TITULA", pdf: pdfTitula },
];

const DocumentosGestion = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
    document.body.style.overflow = "hidden"; 
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
    document.body.style.overflow = "auto"; 
  };

  return (
    <section className="doc-page py-5">
       {/* Banner superior */}
       <div className="info-hero" 
      >
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Documentos de Gestión Institucional</h1>
          <p className="lead">
            Accede a los principales instrumentos de gestión del IESTP .
          </p>
        </div>
      </div>


      <div className="container text-center">
        

        <div className="row g-4 justify-content-center">
          {documentos.map((doc, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <div className="pdf-card shadow-sm rounded-4 bg-white p-4 text-center">
                <div className="doc-icon mb-3">
                  <FaFilePdf size={80} color="#c62828" />
                </div>
                <h5 className="fw-bold mb-3 text-primary">{doc.titulo}</h5>
                <button
                  onClick={() => handleOpenPdf(doc.pdf)}
                  className="btn btn-doc"
                >
                  <FaFilePdf className="me-2" /> Ver Documento
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

   
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="Vista PDF"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default DocumentosGestion;
